export default (obj) => {
  // eslint-disable-next-line no-return-assign,no-param-reassign
  Object.keys(obj).forEach((key) => (obj[key] = key));
  return obj;
};
